/* WTF drawer v2, 2026-10-13. Spec: drawer-v2 SPEC.md. Loaded by snippets/cart-drawer.liquid on every page (defer).
   1) Upsell "Add": one POST /cart/add with sections, painted by the theme's own CartDrawer.renderContents.
   2) An open personalization panel stays open after a drawer re-render (matched by data-key: variant id + md5 of the visible properties).
   3) After a failed quantity change (network error) the stepper input goes back to the quantity the server rendered.
   4) v2.3 "Pairs great with" carousel: arrows, and the recommendation cards (sections/wtf-cart-recs.liquid through /recommendations/products, intent complementary then related).
   5) v2.4 measurement (2026-10-13): a carousel Add sends the hidden line properties _wtf_src = cart_pairs and _wtf_pairs_pos = card position (1-6) in the same /cart/add call,
      and tells assets/wtf-pairs-track.js (event wtf:pairs-added) when the cart accepted it.
   The Edit-personalization flow was removed 2026-10-13 after judge-qa BLOCK (SPEC section 2 fallback).
   No dependency. Every failure leaves the cart as it was. Never touches checkout. */
(function () {
  'use strict';
  if (window.__wtfDrawerV2) return;
  window.__wtfDrawerV2 = true;

  var SECTIONS = 'cart-drawer,cart-icon-bubble';
  var T = {
    adding: 'Adding',
    fail: 'Could not add this item. Please try again.',
    size: 'Choose a size first.'
  };

  function drawer() { return document.querySelector('cart-drawer'); }
  function routes(k, d) { return (window.routes && window.routes[k]) || d; }
  function post(url, body, type) {
    var c = typeof fetchConfig === 'function'
      ? fetchConfig(type || 'json')
      : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/' + (type || 'json') } };
    c.body = JSON.stringify(body);
    return fetch(url, c).then(function (r) { return r.json(); });
  }
  function paint(state) {
    var d = drawer();
    if (!d || typeof d.renderContents !== 'function' || !state || !state.sections) return;
    d.renderContents(state);
    /* The tapped button is gone after the re-render: give focus back to the first line title, inside the drawer's focus trap. */
    setTimeout(function () {
      var t = document.querySelector('#CartDrawer .cart-item__name');
      var c = document.getElementById('CartDrawer');
      if (t && c && typeof trapFocus === 'function') trapFocus(c, t);
    }, 50);
  }

  /* 1) Upsell add */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-wtf-up-add]') : null;
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var card = btn.closest('[data-wtf-up]');
    var msg = card ? card.querySelector('[data-wtf-up-msg]') : null;
    var sel = card ? card.querySelector('[data-wtf-up-size]') : null;
    var id = btn.getAttribute('data-variant-id') || (sel ? sel.value : '');
    if (!id) {
      if (msg) msg.textContent = T.size;
      if (sel) sel.focus();
      return;
    }
    if (msg) msg.textContent = '';
    var li = btn.closest('.wtf-up__card');
    var pos = li && li.parentNode ? Array.prototype.indexOf.call(li.parentNode.children, li) + 1 : 0;
    if (pos > 6) pos = 6;
    var item = { id: Number(id), quantity: 1 };
    if (pos >= 1) item.properties = { _wtf_src: 'cart_pairs', _wtf_pairs_pos: String(pos) };
    var label = btn.textContent;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = T.adding;
    post(routes('cart_add_url', '/cart/add'), {
      items: [item],
      sections: SECTIONS,
      sections_url: window.location.pathname
    }, 'javascript')
      .then(function (state) {
        if (!state || state.status || !state.sections) throw new Error('add');
        paint(state);
        try { document.dispatchEvent(new CustomEvent('wtf:pairs-added', { detail: { pos: pos, variantId: id } })); } catch (e2) { /* measurement only */ }
      })
      .catch(function () {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        btn.textContent = label;
        if (msg) msg.textContent = T.fail;
      });
  });

  /* 2) Keep an open personalization panel open across re-renders */
  var openKeys = {};
  document.addEventListener('toggle', function (e) {
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains('wtf-line__props')) return;
    var k = t.getAttribute('data-key');
    if (!k) return;
    if (t.open) openKeys[k] = 1; else delete openKeys[k];
  }, true);
  function reopen() {
    var list = document.querySelectorAll('#CartDrawer details.wtf-line__props[data-key]');
    for (var i = 0; i < list.length; i++) {
      if (openKeys[list[i].getAttribute('data-key')] && !list[i].open) list[i].open = true;
    }
  }
  var root = document.getElementById('CartDrawer');
  if (root && 'MutationObserver' in window) new MutationObserver(reopen).observe(root, { childList: true, subtree: true });

  /* 3) Failed quantity change: Dawn's cart.js writes its error text into #CartDrawer-CartErrors and leaves the input at the
     failed value, so the next + or - would send the wrong number. When that text arrives, put every stepper back to the
     quantity the server rendered (the input's value attribute). */
  function resetQuantities() {
    var inputs = document.querySelectorAll('#CartDrawer input.quantity__input[name="updates[]"]');
    for (var i = 0; i < inputs.length; i++) {
      var served = inputs[i].getAttribute('value');
      if (served !== null && inputs[i].value !== served) inputs[i].value = served;
    }
  }
  if (root && 'MutationObserver' in window) {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var r = records[i];
        if (r.target && r.target.id === 'CartDrawer-CartErrors' && r.addedNodes && r.addedNodes.length) { resetQuantities(); return; }
      }
    }).observe(root, { childList: true, subtree: true });
  }
  /* 4) Pairs great with carousel (v2.3). The first card is server-rendered (snippets/wtf-cart-upsell.liquid). This code
     adds up to 5 recommendation cards, wires the < > arrows (44 px taps, one card per tap) and keeps their disabled state in step.
     Cards come from the Section Rendering API: /recommendations/products?section_id=wtf-cart-recs&product_id=<first line>&limit=6&intent=...
     Any failure leaves the carousel as the server rendered it. Reads only; never touches the cart. */
  var MAX_CARDS = 6;
  var recsCache = {};
  function trackOf(w) { return w.querySelector('[data-wtf-up-track]'); }
  function reduced() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function arrows(w) {
    var tr = trackOf(w); if (!tr) return;
    var prev = w.querySelector('[data-wtf-up-prev]'), next = w.querySelector('[data-wtf-up-next]');
    var max = tr.scrollWidth - tr.clientWidth;
    if (prev) prev.disabled = tr.scrollLeft <= 2;
    if (next) next.disabled = tr.scrollLeft >= max - 2;
  }
  function wire(w) {
    var tr = trackOf(w); if (!tr) return;
    var prev = w.querySelector('[data-wtf-up-prev]'), next = w.querySelector('[data-wtf-up-next]');
    function step(dir) {
      var card = tr.querySelector('.wtf-up__card'); if (!card) return;
      var gap = parseFloat(getComputedStyle(tr).columnGap) || 12;
      tr.scrollBy({ left: dir * (card.offsetWidth + gap), behavior: reduced() ? 'auto' : 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    var tick = 0;
    tr.addEventListener('scroll', function () { if (tick) return; tick = requestAnimationFrame(function () { tick = 0; arrows(w); }); }, { passive: true });
    arrows(w);
  }
  function parseCards(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var box = doc.querySelector('.wtf-recs');
    return { source: box ? box.getAttribute('data-source') : '', cards: box ? [].slice.call(box.querySelectorAll('.wtf-up__card')) : [] };
  }
  function getRecs(pid, intent) {
    var url = '/recommendations/products?section_id=wtf-cart-recs&product_id=' + encodeURIComponent(pid) + '&limit=6&intent=' + intent;
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' } })
      .then(function (r) { if (!r.ok) throw new Error('recs ' + r.status); return r.text(); })
      .then(parseCards);
  }
  function fill(w, cards) {
    var tr = trackOf(w); if (!tr) return;
    var have = {};
    [].forEach.call(tr.querySelectorAll('.wtf-up__card'), function (c) { have[c.getAttribute('data-product-id')] = 1; });
    var inCart = (w.getAttribute('data-cart-ids') || '').split(',');
    cards.forEach(function (c) {
      var id = c.getAttribute('data-product-id');
      if (have[id] || inCart.indexOf(id) !== -1) return;
      if (tr.querySelectorAll('.wtf-up__card').length >= MAX_CARDS) return;
      have[id] = 1;
      tr.appendChild(document.importNode(c, true));
    });
    arrows(w);
  }
  function load(w) {
    var pid = w.getAttribute('data-product-id'); if (!pid) return;
    var key = pid + '|' + (w.getAttribute('data-cart-ids') || '');
    if (recsCache[key]) { fill(w, recsCache[key].map(function (h) { var t = document.createElement('template'); t.innerHTML = h; return t.content.firstElementChild; })); return; }
    getRecs(pid, 'complementary')
      .then(function (a) { return a.source === 'recs' && a.cards.length ? a : getRecs(pid, 'related').then(function (b) { return b.cards.length ? b : a; }); })
      .then(function (res) {
        recsCache[key] = res.cards.map(function (c) { return c.outerHTML; });
        if (document.body.contains(w)) fill(w, res.cards);
      })
      .catch(function () { /* leave the carousel as rendered */ });
  }
  /* 2026-10-14 (speed build 1, audit 11): the carousel is filled only while the drawer is OPEN. Before, every page load with items in the cart
     fetched and parsed 1-2 /recommendations/products answers for a drawer nobody had opened. Now: the first open (a class change on
     <cart-drawer>) or a re-render while it is open starts the work. The server-rendered first card is there either way. */
  function drawerOpen() { var d = drawer(); return !!(d && d.classList.contains('active')); }
  var hydrating = 0;
  function hydrate() {
    hydrating = 0;
    if (!drawerOpen()) return;
    var list = document.querySelectorAll('#CartDrawer [data-wtf-up]:not([data-wtf-ready])');
    for (var i = 0; i < list.length; i++) { list[i].setAttribute('data-wtf-ready', '1'); wire(list[i]); load(list[i]); }
  }
  function queueHydrate() { if (!hydrating && drawerOpen()) hydrating = requestAnimationFrame(hydrate); }
  if (root && 'MutationObserver' in window) new MutationObserver(queueHydrate).observe(root, { childList: true, subtree: true });
  var drawerEl = drawer();
  if (drawerEl && 'MutationObserver' in window) new MutationObserver(queueHydrate).observe(drawerEl, { attributes: true, attributeFilter: ['class'] });
  queueHydrate();
  /* 2026-10-14 (audit 25): one requestAnimationFrame per burst of resize events (iPhone fires resize while the URL bar moves). */
  var resizing = 0;
  window.addEventListener('resize', function () {
    if (resizing) return;
    resizing = requestAnimationFrame(function () {
      resizing = 0;
      [].forEach.call(document.querySelectorAll('#CartDrawer [data-wtf-up]'), arrows);
    });
  });
})();
